export default __webpack_public_path__ + "static/cells-3b392c2f68fd6a3f56868a700cb78126.jpg";